import React, { useContext, useEffect, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ContentLoadingScreen from "../../components/ContentLoadingScreen";
import PageHeader from "../../components/PageHeader";
import DASHBOARDAPI from "../../services/DashBoardService";
import { axiosPrivate } from "../../services/axios";
import ListingPage from "../../components/ListingPage";
import { useNavigate } from "react-router-dom";
import { PATH_PAGE } from "../../routes/paths";
import { formatToYYYYMonDD } from "../../utils/customC2CFormat";
import { fCurrency } from "../../utils/formatNumber";
import { fCapitalizeFirst } from "../../utils/formatString";
import NavigationContext from "../../contexts/NavigationContext";
import { LOCAL_STORAGE_TOKENS } from "../../utils/constants";
import { useSelectedTab } from "../../contexts/SelectedTabContext";
import useClient from "../../hooks/useClient";

const DashBoardCustomView = () => {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(false);
  const [sortOrder, setSortOrder] = useState("");
  const [refreshKey, setRefreshKey] = useState(0); // For forcing ListingPage to reload
  const navigate = useNavigate();
  const { localKey_selectedClient } = LOCAL_STORAGE_TOKENS;
  const navigationContext = useContext(NavigationContext);
  const contractTypesConfig = navigationContext?.estimationConfig;
  const { setSelectedNavigationTab } = useSelectedTab();
  const { setSelectedClient } = useClient();
  const columns = [
    {
      id: "client_name",
      label: "Client Name",
      align: "left",
      format: (dataItem) => {
        return dataItem?.client_name ? (
          <Box
            component="span"
            sx={{
              color: "primary.main",
              cursor: "pointer"
            }}
            onClick={(e) => {
              const clientData = {
                uuid: dataItem.client_id,
                name: dataItem.client_name
              };
              localStorage.setItem(
                localKey_selectedClient,
                JSON.stringify(clientData)
              );
              setSelectedClient(clientData);

              localStorage.setItem(
                "selectedTab",
                dataItem.business_unit === "business_unit_2"
                  ? "client"
                  : "budget"
              );
              e.stopPropagation();
              navigate(PATH_PAGE.client.detail, {
                state: {
                  client_id: dataItem.client_id,
                  client_name: dataItem.client_name,
                  page: "active_contracts"
                }
              });
            }}
          >
            {fCapitalizeFirst(dataItem.client_name)}
          </Box>
        ) : (
          "--"
        );
      }
    },
    {
      id: "contract_name",
      label: "Contract Name",
      align: "left",
      format: (dataItem) => {
        return dataItem?.contract_name ? (
          <Box
            component="span"
            sx={{
              color: "primary.main",
              cursor: "pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
              const clientData = {
                uuid: dataItem.client_id,
                name: dataItem.client_name
              };
              localStorage.setItem(
                localKey_selectedClient,
                JSON.stringify(clientData)
              );
              localStorage.setItem(
                "selectedTab",
                dataItem.business_unit === "business_unit_2"
                  ? "client"
                  : "budget"
              );
              navigate(PATH_PAGE.contracts.detail, {
                state: {
                  uuid: dataItem.contract_id,
                  client_id: dataItem.client_id,
                  client_name: dataItem.client_name,
                  page: "active_contracts"
                }
              });
            }}
          >
            {fCapitalizeFirst(dataItem.contract_name)}
          </Box>
        ) : (
          "--"
        );
      }
    },

    {
      id: "allocation_name",
      label: "Allocation Name",
      align: "left",
      format: (dataItem) => {
        return dataItem?.allocation_name ? (
          <Box
            component="span"
            sx={{
              color: "primary.main",
              cursor: "pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
              const clientData = {
                uuid: dataItem.client_id,
                name: dataItem.client_name
              };
              localStorage.setItem(
                localKey_selectedClient,
                JSON.stringify(clientData)
              );
              const selectedTab =
                dataItem.business_unit === "business_unit_2"
                  ? "client"
                  : "budget";

              localStorage.setItem("selectedTab", selectedTab);
              setSelectedNavigationTab(selectedTab);
              navigate(PATH_PAGE.allocation.detail, {
                state: {
                  uuid: dataItem.allocation_id,
                  client_id: dataItem.client_id,
                  client_name: dataItem.client_name,
                  page: "active_contracts"
                }
              });
            }}
          >
            {fCapitalizeFirst(dataItem.allocation_name)}
          </Box>
        ) : (
          "--"
        );
      }
    },
    {
      id: "start_date",
      label: "Start Date",
      align: "center",
      format: (dataItem) =>
        dataItem?.start_date ? formatToYYYYMonDD(dataItem.start_date) : "--"
    },
    {
      id: "end_date",
      label: "End Date",
      align: "center",
      format: (dataItem) =>
        dataItem?.end_date ? formatToYYYYMonDD(dataItem.end_date) : "--"
    },
    {
      id: "project_cost",
      label: "Contract Amount",
      align: "center",
      format: (dataItem) =>
        dataItem?.project_cost !== undefined
          ? Number(dataItem.project_cost) === 0
            ? "$ 0"
            : fCurrency(dataItem.project_cost)
          : "--"
    }
  ];

  function fetchDataListAPI(axiosPrivate) {
    return DASHBOARDAPI.GET_ACTIVE_CONTRACTS(axiosPrivate, sortOrder);
  }

  // Handle dropdown change
  const handleSortChange = (e) => {
    setSortOrder(e.target.value);
    setRefreshKey((prev) => prev + 1); // Triggers ListingPage to reload
  };

  return (
    <Box sx={{ p: 2, height: "100vh" }}>
      {loading ? (
        <ContentLoadingScreen />
      ) : (
        <>
          <PageHeader
            primaryTitle="Active Contracts"
            showSecondaryTitle={false}
            showBack={true}
          />
          {/* Sort Dropdown */}

          <Box sx={{ mb: 2, width: 300 }}></Box>

          <ListingPage
            key={refreshKey}
            column={columns}
            noDataMsgId="No Active Contracts Found"
            fetchListAPI={fetchDataListAPI}
            screen="Contracts"
            searchType="active_sowcontract"
            searchByPlaceholder="Search Contract or Client"
            hideInactiveDelete={false}
            displaySorting={true}
            sortOrder={sortOrder}
            handleSortChange={handleSortChange}
          />
        </>
      )}
    </Box>
  );
};

export default DashBoardCustomView;
